import { Menu, MenuItem, MenuList, MenuPopover, MenuTrigger } from '@fluentui/react-components';
import React from 'react';
import {
    ArrowExport20Regular,
    ArrowRedo16Regular,
    ArrowUndo16Regular,
    Delete20Regular,
    EditArrowBack16Regular,
    Mic16Regular,
    MicOff16Regular,
    MoreVertical16Regular,
    Sparkle16Filled,
    TaskListSquareAdd20Regular,
    TextAlignLeft20Regular,
    TextBulletList20Regular,
    Mic20Regular,
    MicOff20Regular,
} from '@fluentui/react-icons';

import styles from './index.module.css';

function undoChange() {
    this.quill.history.undo();
}

function redoChange() {
    this.quill.history.redo();
}

export const getModules = (toolbarId = 'toolbar') => ({
    toolbar: {
        container: `#${toolbarId}`,
        handlers: {
            undo: undoChange,
            redo: redoChange,
        },
    },
    history: {
        delay: 1000,
        maxStack: 100,
        userOnly: true,
    },
    clipboard: {
        matchVisual: false,
    },
});

export const formats = ['header', 'bold', 'italic', 'underline', 'strike', 'list', 'bullet', 'script', 'indent', 'direction', 'link', 'image', 'blockquote', 'code-block', 'clean'];

export const QuillToolbar = ({
    sidebar = false,
    toolbarId = 'toolbar',
    handleEntryDeleteClick = () => {},
    handleRewriteWithAI = () => {},
    handleMoveEntry = () => {},
    isDictating = false,
    onToggleDictation = () => {},
}) => {
    const handleAIAction = mode => {
        handleRewriteWithAI(mode);
    };

    return (
        <div className={styles.formatToolbar}>
            <div id={toolbarId} className={styles.formatToolbarQuill}>
                {!sidebar && (
                    <span className="ql-formats">
                        <button type="button" className="ql-undo" aria-label="Undo">
                            <ArrowUndo16Regular color="#6B6F89" />
                        </button>
                        <button type="button" className="ql-redo" aria-label="Redo">
                            <ArrowRedo16Regular color="#6B6F89" />
                        </button>
                    </span>
                )}
                <span className="ql-formats">
                    <button type="button" className="ql-bold" />
                    <button type="button" className="ql-italic" />
                    <button type="button" className="ql-underline" />
                    <button type="button" className="ql-strike" />
                </span>
                <span className="ql-formats">
                    <select className="ql-header" defaultValue="">
                        <option value="">Normal</option>
                        <option value="2">Heading</option>
                        <option value="3">Subheading</option>
                        <option value="4">Small Heading</option>
                    </select>
                </span>
                <span className="ql-formats">
                    <button type="button" className="ql-list" value="bullet" />
                    <button type="button" className="ql-list" value="check" />
                </span>
                {!sidebar && (
                    <span className="ql-formats">
                        <button type="button" className="ql-link" />
                        <button type="button" className="ql-image" />
                    </span>
                )}
            </div>
            {!sidebar && (
                <div className={styles.formatToolbarActions}>
                    <Menu>
                        <MenuTrigger disableButtonEnhancement>
                            <button type="button" className={styles.aiToolsBtn} aria-label="AI Tools">
                                <Sparkle16Filled color="#ffffff" />
                                AI Tools
                            </button>
                        </MenuTrigger>
                        <MenuPopover>
                            <MenuList>
                                <MenuItem icon={<EditArrowBack16Regular color="var(--Brand-Secondary)" />} onClick={() => handleAIAction('rewrite')}>
                                    <span style={{ color: 'var(--Brand-Secondary)' }}>Rewrite</span>
                                </MenuItem>
                                <MenuItem icon={<TextAlignLeft20Regular color="var(--Brand-Secondary)" />} onClick={() => handleAIAction('summary')}>
                                    <span style={{ color: 'var(--Brand-Secondary)' }}>Summary</span>
                                </MenuItem>
                                <MenuItem icon={<TextBulletList20Regular color="var(--Brand-Secondary)" />} onClick={() => handleAIAction('keypoints')}>
                                    <span style={{ color: 'var(--Brand-Secondary)' }}>Keypoints</span>
                                </MenuItem>
                                <MenuItem icon={<TaskListSquareAdd20Regular color="var(--Brand-Secondary)" />} onClick={() => handleAIAction('tasks')}>
                                    <span style={{ color: 'var(--Brand-Secondary)' }}>Create Tasks</span>
                                </MenuItem>
                            </MenuList>
                        </MenuPopover>
                    </Menu>
                    <Menu>
                        <MenuTrigger disableButtonEnhancement>
                            <button type="button" className={styles.iconBtn} aria-label="Entry actions">
                                <MoreVertical16Regular color="var(--Neutral-Gray-6)" />
                            </button>
                        </MenuTrigger>
                        <MenuPopover>
                            <MenuList>
                                <MenuItem icon={<ArrowExport20Regular color="var(--Brand-Secondary)" />} onClick={() => handleMoveEntry()}>
                                    <span style={{ color: 'var(--Brand-Secondary)' }}>Move</span>
                                </MenuItem>
                                <MenuItem icon={<Delete20Regular color="var(--Brand-Secondary)" />} onClick={() => handleEntryDeleteClick()}>
                                    <span style={{ color: 'var(--Brand-Secondary)' }}>Delete entry</span>
                                </MenuItem>
                            </MenuList>
                        </MenuPopover>
                    </Menu>
                    <button
                        type="button"
                        className={`${styles.toolbarMicBtn} ${isDictating ? styles.toolbarMicBtnActive : ''}`}
                        onClick={onToggleDictation}
                        aria-label={isDictating ? 'Dictation in progress' : 'Start voice dictation'}
                        aria-pressed={isDictating}
                        title={isDictating ? 'Dictation in progress' : 'Dictate with your voice'}
                        disabled={isDictating}>
                        {isDictating ? <MicOff20Regular /> : <Mic20Regular />}
                    </button>
                </div>
            )}
        </div>
    );
};

export default QuillToolbar;
